/**
 * Store exports
 * Import all stores from a single location
 */

export { useAuthStore, type AuthState } from './auth'
export { useAuthModalStore } from './authModal'
export { useBuilderStore } from './builder'
export {
  useSurveyModalStore,
  shouldShowSurvey,
  recordSurveyDismissal,
} from './surveyModal'
export { useStationeryBuilderStore } from './stationeryBuilder'
export {
  usePopupCampaignModalStore,
  shouldShowPopup,
  recordPopupShown,
  recordLightDismissal,
  recordPopupDismissal,
} from './popupCampaignModal'
